import { render, staticRenderFns } from "./admin_edit_password.vue?vue&type=template&id=88cb6f2c&scoped=true&"
import script from "./admin_edit_password.vue?vue&type=script&lang=js&"
export * from "./admin_edit_password.vue?vue&type=script&lang=js&"
import style0 from "./admin_edit_password.vue?vue&type=style&index=0&id=88cb6f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cb6f2c",
  null
  
)

export default component.exports